import { Pipe, PipeTransform } from '@angular/core';
import { ICruiseDetailCabin } from '../interfaces/icruise-detail-cabin';

@Pipe({
  name: 'orderByFare'
})
export class OrderByFarePipe implements PipeTransform {

  transform(value: { [key: string]: { key: string, bestCabin: ICruiseDetailCabin, cabins: ICruiseDetailCabin[] } }): { key: string, bestCabin: ICruiseDetailCabin, cabins: ICruiseDetailCabin[] }[] {
    const order = ['myCruise', 'myAllinc', 'myExplor'];
    const arrayValue = Object.values(value);
    return arrayValue.sort((a, b) => {
      const indexA = order.indexOf(a.key);
      const indexB = order.indexOf(b.key);
      if (indexA === -1 && indexB === -1) { return a.key.localeCompare(b.key); }
      if (indexA === -1) { return 1; }
      if (indexB === -1) { return -1; }
      return indexA - indexB;
    });
  }

}
